/* eslint-disable react/jsx-props-no-spreading */
import { SVGProps } from 'react';

const CheckIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    data-palette="CheckIcon">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.93238 2.9324C4.22876 1.63604 6.02111 0.833334 7.99998 0.833334C9.97885 0.833334 11.7712 1.63604 13.0676 2.9324C14.3639 4.22878 15.1666 6.02113 15.1666 8C15.1666 9.97887 14.3639 11.7712 13.0676 13.0676C11.7712 14.364 9.97885 15.1667 7.99998 15.1667C6.02111 15.1667 4.22876 14.364 2.93238 13.0676C1.63602 11.7712 0.833313 9.97887 0.833313 8C0.833313 6.02113 1.63602 4.22878 2.93238 2.9324Z"
      fill="#2894F9"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.6869 5.64645C11.8821 5.84171 11.8821 6.15829 11.6869 6.35355L7.68687 10.3536C7.4916 10.5488 7.17502 10.5488 6.97976 10.3536L4.97976 8.35356C4.7845 8.15829 4.7845 7.84171 4.97976 7.64645C5.17502 7.45119 5.4916 7.45119 5.68687 7.64645L7.33331 9.2929L10.9798 5.64645C11.175 5.45119 11.4916 5.45119 11.6869 5.64645Z"
      fill="#262832"
    />
  </svg>
);

export default CheckIcon;
